import React, { useMemo } from 'react';
import dayjs from 'dayjs';
import { cn } from '../../../../../../utils/styles';
import { IFiltersState } from '../index';
import { Button } from '../../../../../../components/Common/UI/Button';
import DatePicker from '../../../../../../components/Common/UI/DataPicker';
import Icons from '../../../../../../components/Common/Icons/Icons';
import { Input } from '../../../../../../components/Common/UI/Input';

interface IFilterBlock {
  title: string;
  filters: string[];
  state: IFiltersState;
  group: keyof IFiltersState;
  handleDispatch: (payload: Partial<IFiltersState>) => void;
}

function FilterBlock({ title, filters, state, group, handleDispatch }: IFilterBlock) {
  const groupState = state[group];
  const selectedFilterType = useMemo(() => state[group].selected, [state]);

  return (
    <div className="grid gap-[20px]">
      <div className="font-medium text-[18px] opacity-80 leading-[20px]">{title}</div>
      <div className="flex flex-wrap gap-[10px]">
        {filters.map(el => (
          <Button
            key={el}
            className={cn(
              'p-[5px] text-[12px] font-medium h-[24px] rounded-[2px] !bg-secondary-10 ' +
                '!text-secondary-80 uppercase min-w-[85px]',
              {
                '!bg-secondary !text-white': el === groupState.selected,
              },
            )}
            onClick={() => handleDispatch({ [group]: { ...groupState, selected: el } })}
          >
            {el}
          </Button>
        ))}
      </div>

      {groupState.from ? (
        <div className="flex flex-wrap items-center gap-2">
          <DatePicker
            prefix="From"
            date={dayjs(groupState.from).toDate()}
            className="font-normal bg-addition6-5 sm:w-auto w-full"
            icon={<Icons.Calendar2 className="ml-[15px] opacity-40" />}
            onSelect={(date?: Date) => {
              handleDispatch({ [group]: { ...groupState, from: date?.toString() } });
            }}
          />
          {selectedFilterType === 'between' ? (
            <>
              <Icons.ArrowLeft className="sm:block hidden" />
              <DatePicker
                prefix="To"
                icon={<Icons.Calendar2 className="ml-[15px] opacity-40" />}
                className="font-normal bg-addition6-5 sm:w-auto w-full"
                date={dayjs(groupState.to).toDate()}
                onSelect={(date?: Date) => {
                  handleDispatch({ [group]: { ...groupState, to: date?.toString() } });
                }}
              />
            </>
          ) : null}
        </div>
      ) : null}
      <div className="flex gap-4 items-center">
        {groupState.amount !== undefined ? (
          <Input
            value={groupState.amount}
            inputClassName="text-addition1 max-w-[185px] bg-addition6-5"
            onChange={e => {
              handleDispatch({ [group]: { ...groupState, amount: e.target.value } });
            }}
          />
        ) : null}
        {groupState.amount2 !== undefined && selectedFilterType === 'between' ? (
          <>
            <span>to</span>
            <Input
              value={groupState.amount2}
              inputClassName="text-addition1 max-w-[185px] bg-addition6-5"
              onChange={e => {
                handleDispatch({ [group]: { ...groupState, amount2: e.target.value } });
              }}
            />
          </>
        ) : null}
      </div>
    </div>
  );
}

export default FilterBlock;
